'use client';

import { Mail, Phone, Building2 } from 'lucide-react';
import { SectionHeader } from '../shared';

interface ContactSectionProps {
  data: Record<string, unknown>;
  fields?: string[] | null;
  label?: string | null;
}

export function ContactSection({ data, fields, label }: ContactSectionProps) {
  const email = data.email as string | undefined;
  const phone = data.phone as string | undefined;
  const type = data.type as string | undefined;

  if (!email && !phone && !type) {
    return null;
  }

  return (
    <div>
      <SectionHeader title={label || 'CONTACT'} />
      <div className="space-y-1 text-xs">
        {email && (
          <div className="flex items-center gap-1.5">
            <Mail className="h-3 w-3 text-muted-foreground shrink-0" />
            <a href={`mailto:${email}`} className="hover:underline truncate">
              {email}
            </a>
          </div>
        )}
        {phone && (
          <div className="flex items-center gap-1.5">
            <Phone className="h-3 w-3 text-muted-foreground shrink-0" />
            <a href={`tel:${phone}`} className="hover:underline">
              {phone}
            </a>
          </div>
        )}
        {type && (
          <div className="flex items-center gap-1.5">
            <Building2 className="h-3 w-3 text-muted-foreground shrink-0" />
            <span className="capitalize">{type}</span>
          </div>
        )}
      </div>
    </div>
  );
}
